import React from 'react';
import { Card, Form, Row, Col } from 'react-bootstrap';

const Budget = ({ formData, handleFormChange }) => {
  return (
    <Card className="dark-main-card text-light">
      <Card.Body className="p-3 compact-form">
        <h3 className="mb-3 text-white" style={{ fontSize: "1.5rem" }}>Budget</h3>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-2" controlId="totalBudget">
              <Form.Label>Total Budget</Form.Label>
              <Form.Control
                type="number"
                name="totalBudget"
                value={formData.totalBudget}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-2" controlId="budgetAllocationPriorities">
          <Form.Label>Budget Allocation Priorities</Form.Label>
          <Form.Control
            as="select"
            multiple
            name="budgetAllocationPriorities"
            value={formData.budgetAllocationPriorities}
            onChange={handleFormChange}
            className="dark-input"
          >
            <option value="venue">Venue</option>
            <option value="catering">Catering</option>
            <option value="av">AV</option>
            <option value="staffing">Staffing</option>
          </Form.Control>
        </Form.Group>
        <Form.Group className="mb-2" controlId="spendingConstraints">
          <Form.Label>Spending Constraints</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            name="spendingConstraints"
            value={formData.spendingConstraints}
            onChange={handleFormChange}
            className="dark-input"
          />
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default Budget;